import { render, staticRenderFns } from "./Maintenance.vue?vue&type=template&id=f85dc842&scoped=true&"
var script = {}
import style0 from "./Maintenance.vue?vue&type=style&index=0&id=f85dc842&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f85dc842",
  null
  
)

export default component.exports